module.exports = __webpack_public_path__ + "img/CHBIM_logo.ea84cd32.png";